module.exports = __webpack_public_path__ + "media/images/pic/materials/katakana-573220311b37dc6c601b6be04c2b4353.png";